import padZero from './padZero';

export default function today(): string {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  return `${year}-${padZero(month + 1)}-${padZero(day)}T00:00:00.000`;
}
